import React from 'react';

import { useHistory } from "react-router";
import { getCompanyEssential } from "api/urls";

import CompanyEssentialContainer from 'components/wrapper/CompanyEssentialContainer';
const CompanyEssential = (props) => {

    const history = useHistory()
    const unWantedKeys = ['id', 'created_at', 'updated_at', 'company', 'symbol', 'company_name']

    return (
        <div  {...props}>
            <CompanyEssentialContainer
                url={getCompanyEssential(history.location.search)}
                title={"Company Essentials"}
                unWantedKeys={unWantedKeys}
            />
        </div>
    )
};

export default (CompanyEssential);
